import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`epic-navbar ${scrolled ? "shrink" : ""}`}>
      <div className="nav-inner">

        {/* LOGO */}
        <NavLink to="/" className="logo-box">
          <img src="/assets/images/pyramid.png" alt="Pyramid Logo" />
          <div className="logo-text">
            <span>Pyramid</span>
            <small>Construction</small>
          </div>
        </NavLink>

        {/* LINKS */}
        <nav className="nav-links">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/properties">Our projects</NavLink>
          <NavLink to="/property">Details</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </nav>

      </div>
    </header>
  );
}

export default Navbar;
